import { createFileRoute } from '@tanstack/react-router'
import { useIsMobile } from '@/lib/hooks'
import {
  legalPageWrapper,
  legalHeading,
  legalContent,
  legalTableHeader,
  legalTableCell,
} from '../lib/legalStyles'
import { COLORS } from '@/components/home/tokens'

export const Route = createFileRoute('/sub-processors')({
  component: SubProcessorsPage,
})

const COLOR = COLORS.neutral2

function SubProcessorsPage() {
  const isMobile = useIsMobile()
  return (
    <div style={legalPageWrapper(isMobile)}>
      <div style={{ maxWidth: '700px', margin: '0 auto' }}>
        <h1 style={legalHeading(COLOR)}>Sub-Processors</h1>

        <div style={legalContent(COLOR)}>
          <p style={{ marginBottom: '8px' }}>
            <strong>Last Updated:</strong> May 28, 2026
          </p>
          <p style={{ marginBottom: '36px' }}>
            Reference is made to Section 5.1 of Ent&apos;s Data Processing Addendum.
          </p>

          <div style={{ overflowX: 'auto' }}>
            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
                minWidth: '500px',
              }}
            >
              <thead>
                <tr>
                  <th style={legalTableHeader(COLOR)}>Sub-Processor</th>
                  <th style={legalTableHeader(COLOR)}>Function</th>
                  <th style={legalTableHeader(COLOR)}>Location</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={legalTableCell(COLOR)}>Amazon Web Services (AWS)</td>
                  <td style={legalTableCell(COLOR)}>Cloud Storage</td>
                  <td style={legalTableCell(COLOR)}>USA</td>
                </tr>
                <tr>
                  <td style={legalTableCell(COLOR)}>Anthropic, PBC</td>
                  <td style={legalTableCell(COLOR)}>LLM inference (production) and AI tooling</td>
                  <td style={legalTableCell(COLOR)}>USA</td>
                </tr>
                <tr>
                  <td style={legalTableCell(COLOR)}>Dropbox</td>
                  <td style={legalTableCell(COLOR)}>E-signature and file storage (customer contracts)</td>
                  <td style={legalTableCell(COLOR)}>USA</td>
                </tr>
                <tr>
                  <td style={legalTableCell(COLOR)}>Fathom</td>
                  <td style={legalTableCell(COLOR)}>AI meeting assistant (call recording & transcription)</td>
                  <td style={legalTableCell(COLOR)}>USA</td>
                </tr>
                <tr>
                  <td style={legalTableCell(COLOR)}>Google, LLC</td>
                  <td style={legalTableCell(COLOR)}>Hosting and storage systems provider; email and office applications</td>
                  <td style={legalTableCell(COLOR)}>USA</td>
                </tr>
                <tr>
                  <td style={legalTableCell(COLOR)}>Granola</td>
                  <td style={legalTableCell(COLOR)}>AI meeting assistant (call recording & transcription)</td>
                  <td style={legalTableCell(COLOR)}>USA</td>
                </tr>
                <tr>
                  <td style={legalTableCell(COLOR)}>HubSpot</td>
                  <td style={legalTableCell(COLOR)}>CRM and customer knowledge base / support</td>
                  <td style={legalTableCell(COLOR)}>USA</td>
                </tr>
                <tr>
                  <td style={legalTableCell(COLOR)}>Microsoft</td>
                  <td style={legalTableCell(COLOR)}>Cloud hosting (Azure) and AI inference (Azure OpenAI); email/office applications</td>
                  <td style={legalTableCell(COLOR)}>USA</td>
                </tr>
                <tr>
                  <td style={legalTableCell(COLOR)}>Notion Labs, Inc.</td>
                  <td style={legalTableCell(COLOR)}>Documentation & reporting services (only if customer consents to use)</td>
                  <td style={legalTableCell(COLOR)}>USA</td>
                </tr>
                <tr>
                  <td style={legalTableCell(COLOR)}>Sentry</td>
                  <td style={legalTableCell(COLOR)}>Error and performance monitoring</td>
                  <td style={legalTableCell(COLOR)}>USA</td>
                </tr>
                <tr>
                  <td style={legalTableCell(COLOR)}>Slack Technologies, Inc.</td>
                  <td style={legalTableCell(COLOR)}>Customer communications and data transfer (only if customer consents to use)</td>
                  <td style={legalTableCell(COLOR)}>USA</td>
                </tr>
                <tr>
                  <td style={legalTableCell(COLOR)}>Zoom</td>
                  <td style={legalTableCell(COLOR)}>Video conferencing</td>
                  <td style={legalTableCell(COLOR)}>USA</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}
